import { render, staticRenderFns } from "./materialSettleDetail.vue?vue&type=template&id=2ea5e8a5&scoped=true"
import script from "./materialSettleDetail.vue?vue&type=script&lang=js"
export * from "./materialSettleDetail.vue?vue&type=script&lang=js"
import style0 from "./materialSettleDetail.vue?vue&type=style&index=0&id=2ea5e8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea5e8a5",
  null
  
)

export default component.exports